import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 検索書類設定情報
 */
export function GetDocSetInfoData() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetDocSetInfoData)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 編集書類設定情報
 */
export function EditDocSetInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.EditDocSetInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * レートマスタデータの検索
 */
export function SearchExchangeRateData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchExchangeRateData, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * レートマスタデータの更新
 */
export function UpdateExchangeRateData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateExchangeRateData, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

